var map = {
	"./5-CN-old.png": "rtnt",
	"./5-CN.png": "MVgV",
	"./5-EN-old.png": "TaPP",
	"./5-EN.png": "rj5Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mQdZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/5\-.*\.png$
// module id = mQdZ
// module chunks = 1